import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { WorldIcon, StarIcon, Oval1Icon, RopIcon } from "../constant";
import { styled } from "@mui/material/styles";

const MainContainer = styled(Box)(({ theme }) => ({
    background: "#000",
    display: "flex",
    flexDirection: "column",
    padding: "60px 24px",
    position: "relative",
    overflow: "hidden",
    width: "100%",
    margin: "0 auto",

    "&::after": {
        content: '""',
        position: "absolute",
        width: "90%",
        height: "100%",
        right: "60%",
        top: "0",
        bottom: "10%",
        transform: "translateX(-100%), translateY(-50%)",
        background:
            "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
        filter: "blur(100px)",
       // backdropFilter: "blur(500px)",
        zIndex: 0,
    },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
    width: "100%", // Set to 95% width
    maxWidth: "1200px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
        width: "97%",
    },
}));





const FourCardsSwap = ({ title, subTitle, cardData }) => {
    return (
        <MainContainer>
            <ContentContainer>
                <Box  
                    sx={{ width: { xs: "100%",md:"70%" }}}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontSize: { xs: "24px", sm: "32px", md: "40px" },
                            fontWeight: 700,
                            mb:{xs: 2 ,md:5},
                        }}
                    >
                        {title}
                    </Typography>

                </Box>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={8}>
                        <Grid container spacing={1}>
                        <Grid item xs={12} md={9} sx={{minHeight:{xs:"100px",md:"200px"}}}>
                                <Typography
                                    sx={{
                                        color: "#8C8CC2",
                                        fontSize: { xs: "14px", md: "18px" },
                                        lineHeight: 1.8,
                                        textAlign: "left",
                                        marginBottom: {xs:3 ,md:4},
                                    }}
                                >
                                    {subTitle}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <Box className="industrie-action-card1" sx={{ background: "#1A1A1A" }}>
                                    <Box className="industrie-card-body1">

                                        <Box className="info1">
                                            <Typography variant="h4" className="intro-text1">
                                                <img src={RopIcon}
                                                    sx={{
                                                        width: "15%",
                                                        aspectRatio: 3 / 2,
                                                        height: "60px",
                                                    }}
                                                    alt=""
                                                />
                                                <br />
                                                {cardData[0]?.title}
                                            </Typography>
                                            <Typography>{cardData[0]?.description}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <Box className="industrie-action-card1" sx={{ background: "#07329F" }}>
                                    <Box className="industrie-card-body1">
                                        <Box className="info1">
                                            <Typography variant="h4" className="intro-text1">
                                                <img src={WorldIcon}
                                                    sx={{
                                                        width: "15%",
                                                        aspectRatio: 3 / 2,
                                                        height: "60px",
                                                    }}
                                                    alt=""
                                                />
                                                <br />
                                                {cardData[1]?.title}
                                            </Typography>
                                            <Typography>{cardData[1]?.description}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* last card  */}
                    <Grid item xs={12} sm={12} md={12} lg={4}>
                        <Box className="industrie-action-card2" sx={{ background: "#1A1A1A" }}>
                            <Box className="info1">
                                <Box sx={{ display: "flex", justifyContent: "left" }}>
                                    <img
                                        src={Oval1Icon}
                                        style={{
                                            width: "30%",
                                            aspectRatio: 3 / 2,
                                            height: "100px",
                                        }}
                                        alt=""
                                    />
                                </Box>
                                <Box sx={{ textAlign: "left", marginTop: "170px" }}>
                                    <Typography variant="h4" className="intro-text1">
                                        {cardData[2]?.title}
                                    </Typography>
                                    <Typography variant="body2">{cardData[2]?.description}</Typography>
                                </Box>
                            </Box>

                        </Box>
                    </Grid>
                </Grid>

            </ContentContainer>
        </MainContainer>
    );
};

export default FourCardsSwap;


